// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1zAmk","options":"AnswerScale_options__DrFK6","selected":"AnswerScale_selected__3J88b"};